import { rem } from 'polished';
import * as React from 'react';
import styled from 'styled-components';
import ImagePlaceholder from '../_helpers/Image/ImagePlaceholder';

interface StaticBannersProps {
  banners: any[];
  user: any;
}

const StaticBanners = (props: StaticBannersProps) => {
  const { banners } = props;
  return (
    <BannersWrapper>
      {banners?.map((banner) => {
        if (banner.b_url) {
          return (
            <ImageLink href={banner.b_url}>
              {' '}
              <ImageWrapper>
                <ImageBanner
                  src={banner.b_path}
                  notResize={true}
                  aspectRatio="1/0.49"
                  quality={70}
                  wrapperWidth="100%"
                />
              </ImageWrapper>
            </ImageLink>
          );
        } else {
          return (
            <ImageWrapper>
              <ImageBanner
                src={banner.b_path}
                notResize={true}
                aspectRatio="1/0.49"
                quality={70}
                wrapperWidth="100%"
              />
            </ImageWrapper>
          );
        }
      })}
    </BannersWrapper>
  );
};

const BannersWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  row-gap: ${rem(10)};

  ${({ theme }) => theme.media('xs')} {
    grid-template-columns: repeat(3, 1fr);
    gap: ${rem(20)};
  }

  margin-top: ${rem(20)};
  margin-bottom: ${rem(20)};
  width: 100%;
`;

const ImageLink = styled.a`
  height: inherit;
  width: 100%;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: inherit;
  width: 100%;
`;

const ImageBanner = styled(ImagePlaceholder)`
  width: 100%;
  object-fit: cover;

  ${({ theme }) => theme.media('xs')} {
    height: inherit;
  }
`;

export default StaticBanners;
